import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import * as wActs from "../actions/website-actions";
import { FormattedMessage } from "react-intl";
import SeoHeaders from "../components/seoheaders";
import {Link} from "react-router-dom";
import SideBanners from "../components/sidebanners";
import SelectBox from "../components/selectbox";

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      regSelect: "block",
      regForm: "none"
    };
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "signup" });
  }

  componentDidMount() {

  }

  handleClick(evt, tType) {
    evt.preventDefault();
    this.props.dispatch({ type: wConsts.SIGNUP_SET_TYPE, payload: tType });
    this.setState({
      regSelect: "none",
      regForm: "block"
    });
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleCloseAlert() {
    this.setState({ showingAlert: false });
  }
  handleCloseSuccess() {
    this.setState({ showingSuccess: false });
  }




  handleSubmit(evt) {
    evt.preventDefault();
    if(this.formCPassword.value !== this.formPassword.value) {
      this.props.dispatch(wActs.showWarning("WARN","Check your passwords"));
      return;
    }
    const data = {
      "UserName": this.formUsername.value,
      "Password": this.formPassword.value,
      "EmailAddress": this.formEmail.value,
      "Type": this.props.WebPage.SignUp.Type,
      "Source": "escortnews"
    };

    if(data.Type.toLowerCase() == "agent") {
      data.AgentType = this.AgentType.state.value.value;
    }

    //console.log("Data To Post", data);

    this.props.dispatch(wActs.Signup(data,this.props.history, wActs.getCultPath(this.props.WebPage,"/confirm")));
  }

  PopupCenter(url, title, w, h) {
    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }

    return newWindow;
  }


  handleENewsClick(evt) {
    evt.preventDefault();
    this.PopupCenter("https://auth.escortnews.eu/auth/login", "loginWindow", 410, 515);
    window.addEventListener("message", function (event) {
      if (event.origin.toLowerCase().indexOf("oauth") > 0) {
        if (event.data.token_type === "Bearer") {
          let domain = "." + wActs.getSubdomain(window.location.hostname);
          wActs.setCookie("auth", event.data.access_token, { path: "/", maxAge: 31557600, domain: domain });
          window.location = "/";
        }
      } else {
        console.log("Bad Origin", event);
      }
    }, false);
  }



  render() {

    return (

      <React.Fragment>
        <SeoHeaders Position={"Top"}/>
        <div className="row">
          <div className="col_80">
            <div className="white-box the-content">
            <div className="heading">
              <div className="cell x12">
                {this.state.regForm!="block" && <h3>{this.getTranslation("page.signup.howdoyouwanttosignup")}</h3>}
                <p>{this.getTranslation("page.signup.alreadyhaveaccount")} <Link to={wActs.getCultPath(this.props.WebPage,"/login")} title=""><FormattedMessage id={"page.signup.loginhere"}>{(...content) => content}</FormattedMessage></Link></p>
              </div>
              <div className="clear"></div>
            </div>


            <div id="register-select" style={{background: "#fff", display: this.state.regSelect, padding: "5px", marginBottom: "150px"}}>
              <div className="regular-content">
                <div className="row" style={{marginLeft: "10px", marginRight: "10px"}}>
                  <div className="cell x4">
                    <a style={{width: "100%"}} href=" #" title="" onClick={(e) => { this.handleClick(e, "member"); }} className=""><img src="/imgs/member-bg.jpg" alt="Member" style={{width: "100%"}} /></a>
                    <a href=" #" title="" onClick={(e) => { this.handleClick(e, "member"); }} className="memberbutton" style={{ width: "100%", maxWidth: "100%", minWidth: "100%" }}>{this.getTranslation("page.signup.member")}</a>
                  </div>
                  <div className="cell x4">
                    <a style={{width: "100%"}} href=" #" title="" onClick={(e) => { this.handleClick(e, "independentmodel"); }} className=""><img src="/imgs/model-bg.jpg" alt="Model" style={{width: "100%"}} /></a>
                    <a href=" #" title="" onClick={(e) => { this.handleClick(e, "independentmodel"); }} className="memberbutton" style={{ width: "100%", maxWidth: "100%", minWidth: "100%" }}>{this.getTranslation("page.signup.independentmodel")}</a>
                  </div>
                  <div className="cell x4">
                    <a style={{width: "100%"}} href=" #" title="" onClick={(e) => { this.handleClick(e, "agent"); }} className=""><img src="/imgs/agency-bg.jpg" alt="Agency" style={{width: "100%"}} /></a>
                    <a href=" #" title="" onClick={(e) => { this.handleClick(e, "agent"); }} className="memberbutton" style={{ width: "100%", maxWidth: "100%", minWidth: "100%" }}>{this.getTranslation("page.signup.agencycompany")}</a>
                  </div>
                </div>
              </div>
            </div>


            <div className="form" style={{display: this.state.regForm, marginBottom: "150px"}}>
              <div className="cell x12">
                <form action="">

                  {this.props.SignUp.Type == "agent" &&
                  <p className="w-icon" style={{maxWidth: "100%", marginBottom: "12px"}}>
                    <SelectBox options={this.props.AgentTypes} ref={(r)=>{this.AgentType = r}}
                               defaultValue={this.props.DefaultType}
                    />
                  </p>
                  }
                  <p className="w-icon e-mail" style={{maxWidth: "100%"}}><input ref={(r)=>{this.formEmail = r}} type="email" placeholder={this.getTranslation("page.email")}/></p>
                  <p className="w-icon username" style={{maxWidth: "100%"}}><input ref={(r)=>{this.formUsername = r}} type="text" placeholder={this.getTranslation("page.login.username")}/></p>
                  <p className="w-icon password" style={{maxWidth: "100%"}}><input ref={(r)=>{this.formPassword = r}} type="password" placeholder={this.getTranslation("page.login.password")}/></p>
                  <p className="w-icon password" style={{maxWidth: "100%"}}><input ref={(r)=>{this.formCPassword = r}} type="password" placeholder={this.getTranslation("page.signup.confirmpassword")}/></p>
                  <input onClick={(e) => {this.handleSubmit(e)}} type="submit" value="Submit"/>
                </form>
                <div className="or">
                  <div className="divider"></div>
                  <div className="text">Or register with escort networks</div>
                </div>
                <div className="socials-login">
                  <a href="#" onClick={(e) => {
                    this.handleENewsClick(e);
                  }} className="btn red">Login with EscortNews</a>
                </div>
              </div>
              <div className="clear"></div>
            </div>
            </div>

          </div>
          <SideBanners/>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    SignUp: state.Website.SignUp,
    AgentTypes: state.Website.Lists.filter((t) => { return t.Group == "AgentType" && t.Value !== "Unknown" }).map((t) => { return { value: t.Value, label: t.DisplayValue } }),
    DefaultType: state.Website.Lists.filter((t) => { return t.Group == "AgentType" && t.Value == "EscortAgency" }).map((t) => { return { value: t.Value, label: t.DisplayValue } })[0],
  };
};

export default connect(mapStateToProps)(Signup);
